import React from 'react';
import PropTypes from 'prop-types';

import { FlexColumn } from 'ui-components/components/flex';

import { AddressValidationSection } from './address-validation/address-validation-section';
import { ReadOnlyShipTo } from './read-only-shipto';
import { ShipToPropType } from '../../../../../../prop-types/ship-to';

import style from './address.module.less';

const ShipToAddress = ({ shipTo, recipientInfo }) => {
  return (
    <FlexColumn className={style.address}>
      <ReadOnlyShipTo recipientInfo={recipientInfo} shipTo={shipTo} />
      <AddressValidationSection />
    </FlexColumn>
  );
};

ShipToAddress.propTypes = {
  shipTo: ShipToPropType.isRequired,
  recipientInfo: PropTypes.shape({
    name: PropTypes.string,
    email: PropTypes.string,
    phone: PropTypes.string,
  }).isRequired,
};

export default ShipToAddress;
